import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import * as HMS from "../../../common/component/Index";
import Model from '../../../../../constants/Model';
import OrderDetailVoucher from './OrderDetailVoucher';
import moment from 'moment';
import * as CPN from "antd";
import queryString from "query-string";
import DEFINE, { ORDER } from "../../../../../constants/Define";
import FlightDetail from '../OrderDetail/FlightDetail';
import Flight from '../../../../../models/Flight';
import { get } from 'lodash';
class ActionComponent extends Component {
    state = {
        titleOrderItemTable: Func.getTitleTable(Model.OrdersModel.titleOrderItemTable, [], []),
        modelOrderItem: Model.OrdersModel.titleOrderItemTable,
        componentTable: {
            originalPrice: {
                align: "right",
                render: (originalPrice) => Func.formatMoney(originalPrice)
            },
            salePrice: {
                align: "right",
                render: (salePrice) => Func.formatMoney(salePrice)
            },
            quantity: {
                align: "right",
                render: (quantity) => quantity
            },
            priceType: {
                render: (priceType) => i18n.t(`item.tour.priceType.${priceType}`)
            }
        },
        data: {},
        detailGroup: { orders: [] },
        isFetching: false,
        isUpload: false,
    };

    componentDidMount() {
        const { match } = this.props;
        let params = queryString.parse(this.props.location.search);
        if (Object.keys(match.params).length > 0 && match.params.id) {
            this.props.getOrderDetail(match.params.id)
            // if (parseInt(params.type) === 1) {
            //     this.props.onGetOrderVoucherItem({ id: match.params.id, props: this.props });
            //     this.props.onGetInfoVoucherDetailGroupAction({ id: match.params.id });
            // } else if (parseInt(params.type) === 2) {
            //     this.props.onGetOrderItem({ id: match.params.id, props: this.props });
            // } else {
            //     this.props.history.push('/orders/list')
            // }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.orders.dataDetail) {
            this.setState({
                data: nextProps.orders.dataDetail,
                isFetching: nextProps.orders.isFetching,
            })
        }
        if (get(nextProps, 'orders.detail.order.id') && get(nextProps, 'orders.detail.order.id') !== get(this.props, 'orders.detail.order.id')) {
            this.getDetailItems(nextProps.orders.detail.order);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.orders.itemBooking !== prevProps.orders.itemBooking) {
            this.setState({
                detailGroup: {
                    orders: this.props.orders.itemBooking.result,
                    pageSize: this.props.orders.itemBooking.pageSize,
                    pageIndex: this.props.orders.itemBooking.pageIndex,
                    totalCount: this.props.orders.itemBooking.totalCount,
                    totalPage: Math.ceil(parseInt(this.props.orders.itemBooking.totalCount) / parseInt(this.props.orders.itemBooking.pageSize))
                }
            })
        }
    }

    render() {
        const { t } = this.props;
        const { componentTable, isFetching, titleOrderItemTable, modelOrderItem, data, detailGroup } = this.state;
        let params = queryString.parse(this.props.location.search);
        let type = parseInt(params.type);
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isFetching} size={'large'}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'orders'}
                            titleHeader={Func.capitalizeFirstLetter((`${t('action.detail')} ${t('item.order.title')}`.toLowerCase()))
                            }
                        />
                        {
                            type === DEFINE.GENERAL.ORDER_TYPE_DETAIL.TOUR ? (
                                <HMS.FormActionComponent
                                    findParentRoute={() => Func.findParentRoute('orders', this.props)}
                                    disableButtonSubmit={true}
                                    submitButtonRight={true}>
                                    <div className={`col-md-5`}>
                                        <h3 className={`ml-3`}>{t('item.order.orderInfo')}</h3>
                                        <div className={`row mt-2 fs14 order-item`}>
                                            {data && data.tourInfo ?
                                                <HMS.FormWrapperItem>
                                                    <ul className={`mb-0`}>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.orderCode')}:</span> {data.orderCode}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.fullname')}:</span> {data.fullname}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.phoneNumber')}:</span> {data.phoneNumber}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.email')}:</span> {data.email}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.createdDate')}:</span> {moment(data.createdDate).format('DD-MM-YYYY hh:mm')}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.subTotal')}:</span> {Func.formatMoney(data.subTotal)}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.status')}:</span> {data.status == 2 ? i18n.t('item.order.paid') : i18n.t('item.order.unpaid')}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.tourTitle')}:</span>&nbsp;{data.tourInfo.title}
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className={`col-md-12 mb-3 pl-0`}>
                                                                <span
                                                                    className={`semi-bold`}>{t('item.order.departureDate')}:</span>
                                                                <CPN.Icon
                                                                    type="calendar" /> {moment(data.tourInfo.from).format('DD-MM-YYYY')} - <CPN.Icon
                                                                    type="calendar" /> {moment(data.tourInfo.to).format('DD-MM-YYYY')}
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </HMS.FormWrapperItem>
                                                : <CPN.Skeleton active paragraph={{ row: 7 }} />
                                            }
                                        </div>
                                    </div>
                                    <div className={`col-md-7`}>
                                        <h3 className={`ml-3`}>{t('item.order.orderItemInfo')}</h3>
                                        {
                                            data.tourOrderItem &&
                                            <HMS.ListComponent classParent={`order-item`}
                                                rowKey={(record, k) => k}
                                                dataSource={Func.getDataSource(data.tourOrderItem, modelOrderItem)}
                                                columns={Func.columnsTable({
                                                    titleTable: titleOrderItemTable,
                                                    component: componentTable,
                                                    itemName: 'order'
                                                })}
                                                componentTableList={{}}
                                            />
                                        }
                                    </div>
                                    {this.renderFlightInfos()}
                                </HMS.FormActionComponent>
                            ) : type === DEFINE.GENERAL.ORDER_TYPE_DETAIL.VOUCHER && (
                                <OrderDetailVoucher props={this.props} data={detailGroup} isFetching={isFetching} flightInfos={this.renderFlightInfos()} />
                            )
                        }
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        )
    }

    renderFlightInfos = () => {
        return (
            <FlightDetail />
        )
    }

    getDetailItems(order) {
        if(order.itemTypes.includes(ORDER.TYPES.VOUCHER)){
            this.props.onGetOrderVoucherItem({ id: order.id, props: this.props });
            this.props.onGetInfoVoucherDetailGroupAction({ id: order.id });
        }
        if (order.itemTypes.includes(ORDER.TYPES.TOUR)) {
            this.props.onGetOrderItem({ id: order.id, props: this.props });
        }
        if (order.itemTypes.includes(ORDER.TYPES.FLIGHT)) {
            // this.props.onGetOrderFlightDetail({ id: order.id, props: this.props });
        }

    }
}

const mapStateToProps = state => {
    return {
        orders: state.orderReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListOrder: (filters) => {
            dispatch(action.dataOrderAction(filters))
        },
        onGetOrderItem: (params) => {
            dispatch(action.getOrderItemAction(params))
        },
        onGetOrderVoucherItem: (params) => {
            dispatch(action.getItemVoucherOrderAction(params))
        },
        onGetInfoVoucherDetailGroupAction: (params) => {
            dispatch(action.getInfoVoucherDetailGroupAction(params))
        },
        getOrderDetail: (id) => dispatch(action.getOrderDetail(id)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ActionComponent));
